var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen",class:[`bg-${_vm.$route.meta.background}`]},[_c('nav',{staticClass:"main-nav"},[_c('Burger')],1),_c('Sidebar'),_c('MobileMenu'),_c('transition',{attrs:{"name":"zoom","mode":"out-in"},on:{"before-enter":_vm.beforeEnter,"leave":_vm.leave}},[_c('router-view')],1),(_vm.isClassListVisible)?_c('Classes'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }